import { C1LogButton } from 'components/core/log-button/C1LogButton'
import { GrantFeedColumns, GrantFeedSearchFilter } from 'components/pages/entitlement/grant-feed/GrantFeed'
import { GrantFeedDrawer } from 'components/pages/entitlement/grant-feed/GrantFeedDrawer'
import { useDrawer } from 'hooks/useDrawer'
import { FC, useCallback } from 'react'
import { useIntl } from 'react-intl'

type GrantFeedDrawerButtonProps = {
    filter: GrantFeedSearchFilter
    columns?: GrantFeedColumns[]
}

export const GrantFeedDrawerButton: FC<GrantFeedDrawerButtonProps> = ({
    filter, columns,
}) => {
    const intl = useIntl()
    const [showDrawer, close, canClose] = useDrawer()
    const onClick = useCallback(
        () => showDrawer(<GrantFeedDrawer filter={filter} columns={columns} close={close} canClose={canClose} />, { variant: 'md' }),
        [showDrawer, filter, columns, close, canClose],
    )

    return <C1LogButton
        title={intl.formatMessage({
            id: 'entitlement_grant_feed_tooltip',
            defaultMessage: 'View grant feed',
        })}
        onClick={onClick}
    />
}
